export const STORE_URL = "https://team-communication-ready.impultienda.ar";
export const CHECKOUT_URL = "https://team-communication-ready.impultienda.ar/checkout";
export const TRACKING_PARAMS = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","fbclid"];
